import type { ReactElement, ReactNode } from 'react';
import type { TaskDto } from '@gr/core/platform/tasks/dto';
import { TaskCard } from '../TaskCard/TaskCard';
import styles from './TaskList.module.scss';

export interface TaskListProps {
  tasks: readonly TaskDto[];
  /** Что показать, если задач нет. */
  empty: ReactNode;
  timezone?: string;
  showBlog?: boolean;
  compact?: boolean;
  withReportLinks?: boolean;
  canManage(task: TaskDto): boolean;
  pendingId?: string | null;
  onCancel?(task: TaskDto): void;
  onResume?(task: TaskDto): void;
}

/** TASK-UC-2, TASK-UC-3, TASK-UC-6: список фоновых задач. */
export function TaskList({ tasks, empty, timezone, showBlog, compact, withReportLinks, canManage, pendingId, onCancel, onResume }: TaskListProps): ReactElement {
  if (tasks.length === 0) return <>{empty}</>;
  return (
    <ul className={styles.list}>
      {tasks.map((task) => (
        <li key={task.id} className={styles.item}>
          <TaskCard
            task={task}
            timezone={timezone}
            showBlog={showBlog}
            compact={compact}
            withReportLink={withReportLinks}
            canManage={canManage(task)}
            pending={pendingId === task.id}
            onCancel={onCancel}
            onResume={onResume}
          />
        </li>
      ))}
    </ul>
  );
}
